import React from 'react' // eslint-disable-line no-unused-vars
import StaticConfig from '../mi-app/StaticConfig'
import { ABBVIE_EMPLOYEE, ADDRESS_FIELD_NAMES, REQUESTOR_FIELD_NAMES, DISABLE_MODAL_PATHS } from '../constants'
import { PERMISSIONS } from '../constants'

class CountryAwareComponent extends React.Component {
  constructor (props) {
    super(props)
    this.componentName = undefined
    this.block = undefined
    this.childPropFields = undefined
  }

  static selectCountry (selectedCountry) {
    this.countryName = selectedCountry
  }

  componentWillReceiveProps (nextProps) {
    this.countriesMatched()
  }

  getBlockComponent (id, language) {
    var value = document.getElementById(id)
    switch (id) {
      case 'phone':
        //  if (value !== null)
        //  value['innerText'] = StaticConfig.Context.ComponentConfig.phone; // was previously commented
        return
      case 'contactusLink':
        if (value !== null) {
          value.href = 'mailto:' + StaticConfig.Context.ComponentConfig.email
          value.text = StaticConfig.Context.ComponentConfig.email
        }
        break
      default:
        break
    }
    // var updatedValue = document.getElementById(id).getAttribute;
    // // return (
    // //   <a href={field.href}> {field.text} </a>
    // // );
    //
    // case 'button':
    //   return (
    //     <button  type={field.action} className={field.classname}> {field.text} </button>
    //   );
    //
    //   case 'InputGroup':
    //       return (
    //     <InputGroup field= {eval("(" + field.bindfield + ")")} validate= {eval("(" + field.validation + ")")} > </InputGroup>
    //   )
    //
    // default:
    //   return <div className='no_block_type' />
  }

  countriesMatched () {
    let returnValue = true
    if (StaticConfig.Context.switchOn) {
      this.validate()

      if (StaticConfig.Context.ComponentConfig !== null && DISABLE_MODAL_PATHS.indexOf(window.location.pathname) === -1) {
        switch (this.componentName) {
          case 'SubmitInquiry':
          case 'RequestorInformation':
          case 'RequestInformation':
            return this.props.permissions.indexOf(PERMISSIONS.SUBMIT) !== -1
          case 'Search':
          case 'SearchForm':
            return this.props.permissions.indexOf(PERMISSIONS.SEARCH) !== -1
          case 'FindMyMSL':
          case 'FindMyMSLForm':
            return this.props.permissions.indexOf(PERMISSIONS.FINDMYMSL) !== -1
          case 'SiteResources':
            return this.props.permissions.indexOf(PERMISSIONS.SITERESOURCES) !== -1
          case 'Congresses':
            return this.props.permissions.indexOf(PERMISSIONS.CONGRESSINTEGRATION) !== -1
          case 'PrescribingInformation':
            return StaticConfig.Context.ComponentConfig.prescribingInfoUrls
          case 'ContactInformation':
            return (StaticConfig.Context.ComponentConfig.contactInfoAvailable === true)
          case 'PiSearchResult':
            return StaticConfig.Context.ComponentConfig.enablePiSearch
          default:
            returnValue = true
        }
      }
    }

    if (this.componentName === 'RequestorInformation' && StaticConfig.Context.UserType === ABBVIE_EMPLOYEE && StaticConfig.Context.Country.isGMISEnable === 0) {
      return false
    }

    if (this.props.flowType !== 'MI_PORTAL_REQUEST') {
      switch (this.componentName) {
        case 'SubmitInquiry':
        case 'RequestorInformation':
        case 'RequestInformation':
          return true
        default:
          return false
      }
    }
    return returnValue
  }

  _updateFieldConfigurationForCountry = fields => {
    if (this.props.flowType === 'SCIBOOTH') {
      this.updateFieldsForScibooth(fields)
    } else if (this.props.flowType === 'CONFERENCE') {
      this.updateFieldsForScibooth(fields)
      this.updateHcpLicenseNumberRulesForSelectedCountry(fields)
    } else {
      this.updateAddressRulesForSelectedCountry(fields)
      this.updateHcpLicenseNumberRulesForSelectedCountry(fields)
      this.updateGMISBasedFieldConfigurationForSelectedCountry(fields)
      this.updateAffiliationRequirementForUS(fields)
      this.updateAffiliationRequirementForJapan(fields)
    }
    return fields
  }

  updateAffiliationRequirementForUS = fields => {
    if (StaticConfig.Context.Country.affiliate === 'USA') {
      fields.affiliation.rules.required.required = true
      fields.affiliation.rules.ignoreNull = false
    }
    return fields
  }
  updateAffiliationRequirementForJapan = fields => {
 if (StaticConfig.Context.Country.affiliate === 'Japan') {
 fields.affiliation.rules.required.required = true
 fields.affiliation.rules.ignoreNull = false
 }
 return fields
 }
  
  updateFieldsForScibooth (fields) {
    if (StaticConfig.Context.Country.name === 'United States') {
      fields.postalCode.rules.required.required = true
      fields.postalCode.rules.ignoreNull = false
    } else {
      fields.postalCode.rules.required.required = false
      fields.postalCode.rules.ignoreNull = true
    }
  }

  updateGMISBasedFieldConfigurationForSelectedCountry (fields) {
    if (!StaticConfig.Context.Country.isGMISEnable) {
      fields.deliveryMethod.display = false
      fields.deliveryMethod.rules.required.required = false
      fields.deliveryMethod.rules.ignoreNull = true

      REQUESTOR_FIELD_NAMES.forEach(fieldName => {
        fields[fieldName].display = false
        fields[fieldName].rules.required.required = false
        fields[fieldName].rules.ignoreNull = true
      })
    }
  }

  updateHcpLicenseNumberRulesForSelectedCountry (fields) {
    if (StaticConfig.Context.Country.showHcp) {
      fields.hcpLicenseNumber.display = true
    }
    if (StaticConfig.Context.Country.hcpRequired) {
      fields.hcpLicenseNumber.rules.required.required = true
      fields.hcpLicenseNumber.rules.ignoreNull = false
    }
  }

  updateAddressRulesForSelectedCountry (fields) {
    if (StaticConfig.Context.ComponentConfig.addressMandatory) {
      ADDRESS_FIELD_NAMES.forEach(fieldName => {
        fields[fieldName].rules.required.required = true
        fields[fieldName].rules.ignoreNull = false
      })
    }
  }

  validate () {
    if (this.componentName === 'undefined' || this.componentName === '') {
      throw new Error('CountryAwareComponent: No allowed  component name defined! Please define them in the constructor of your component.')
    }
  }
}

export default CountryAwareComponent



// WEBPACK FOOTER //
// ./src/mi-app/CountryAwareComponent.js